import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FatDoctoC } from '../interfaces/fat-docto-c';


@Injectable({
  providedIn: 'root'
})
export class FatDoctoCUtilsService {
  
  buildDoctoCForm(fb: FormBuilder, doctoC: FatDoctoC, disabled : boolean): FormGroup {
    return fb.group({
      // geral
      controle: [doctoC?.controle, { disabled: disabled }],
      emissao: doctoC?.emissao?.toString().split('T')[0],
      dataentradasaida: [doctoC?.dataentradasaida?.toString().split('T')[0]],
      serie: [doctoC?.serie, {disabled: disabled }],
      fatCondPg: [doctoC?.fatCondPg,  [Validators.required]],
      fatListaPrecoTabela: [doctoC?.fatListaPrecoTabela, [Validators.required]],
      fatListaPreco: [doctoC?.fatListaPreco],
      fatTransacao: [doctoC?.fatTransacao,  [Validators.required]],
      cnpjCpf: [doctoC?.cnpjCpf],
      numeroDocto: [doctoC?.numeroDocto],
      cadCadastro: [doctoC?.cadCadastro,  [Validators.required]],
      cadVendedor: [doctoC?.cadVendedor,  [Validators.required]],
      cadastroVendedorId: [doctoC?.cadastroVendedorId],
      emissaotime: [doctoC?.emissaotime],
      fatTransacaoDescricao: [doctoC?.fatTransacaoDescricao],
      fatTransacaoCodigo: [doctoC?.fatTransacaoCodigo],
      vendedorUUID: [doctoC?.vendedorUUID],
      fatListaPrecoTabelaAdapter: [doctoC?.fatListaPrecoTabelaAdapter],
      serieID: [doctoC?.serieID],
      serieNatureza: [doctoC?.serieNatureza],
      seriedoctoCodigo: [doctoC?.seriedoctoCodigo],
      codigo: [doctoC?.codigo],
      bairro: [doctoC?.bairro],
      cadCadastroConsig: [doctoC?.cadCadastroConsig],
      cadCadastroDest: [doctoC?.cadCadastroDest],
      cadCadastroRemet: [doctoC?.cadCadastroRemet],
      cadCadastroTransp: [doctoC?.cadCadastroTransp],
      cadCadastroMotorista: [doctoC?.cadCadastroMotorista],
      cadEstadoIddescarga: [doctoC?.cadEstadoIddescarga],
      cadMunDestino: [doctoC?.cadMunDestino],
      cadMunOrigem: [doctoC?.cadMunOrigem],
      cadVeiculoID: [doctoC?.cadVeiculoId],
      cidade: [doctoC?.cidade],
      cofinsValor: [doctoC?.cofinsValor],
      comissaoAprazo: [doctoC?.comissaoAprazo],
      comissaoAvista: [doctoC?.comissaoAvista],
      comissaofaturamento: [doctoC?.comissaofaturamento],
      comissaorecebimento: [doctoC?.comissaorecebimento],
      complemento: [doctoC?.complemento],
      dadosadicionais: [doctoC?.dadosadicionais],
      dadosadicionaiscontribuinte: [doctoC?.dadosadicionaiscontribuinte],
      outrosDados: [doctoC?.outrosDados],
      dataalteracao: [doctoC?.dataalteracao],
      datainclusao: [doctoC?.datainclusao],
      defeitoconstatado: [doctoC?.defeitoconstatado],
      defeitoreclamado: [doctoC?.defeitoreclamado],
      descarga: [doctoC?.descarga],
      descontoPerc: [doctoC?.descontoPerc],
      descontoValor: [doctoC?.descontoValor],
      descontoclientePerc: [doctoC?.descontoclientePerc],
      descontoclienteValor: [doctoC?.descontoclienteValor],
      descontodoctoPerc: [doctoC?.descontodoctoPerc],
      descontodoctoValor: [doctoC?.descontodoctoValor],
      descontopromoPerc: [doctoC?.descontopromoPerc],
      descontopromoValor: [doctoC?.descontopromoValor],
      despesaBasecalculo: [doctoC?.despesaBasecalculo],
      despesaIsentos: [doctoC?.despesaIsentos],
      despesaOutros: [doctoC?.despesaOutros],
      despesaPercicms: [doctoC?.despesaPercicms],
      despesaPercipi: [doctoC?.despesaPercipi],
      despesaTabred: [doctoC?.despesaTabred],
      despesaTabtri: [doctoC?.despesaTabtri],
      despesaValor: [doctoC?.despesaValor],
      despesaValoricms: [doctoC?.despesaValoricms],
      despesaValoripi: [doctoC?.despesaValoripi],
      endereco: [doctoC?.endereco],
      enderecoNumero: [doctoC?.enderecoNumero],
      especie: [doctoC?.especie],
      frete: [doctoC?.frete],
      freteBasecalculo: [doctoC?.freteBasecalculo],
      freteIsentos: [doctoC?.freteIsentos],
      freteOutros: [doctoC?.freteOutros],
      fretePercipi: [doctoC?.fretePercipi],
      fretePericms: [doctoC?.fretePericms],
      freteSubstvalorfrete: [doctoC?.freteSubstvalorfrete],
      freteSubstvaloricms: [doctoC?.freteSubstvaloricms],
      freteTabred: [doctoC?.freteTabred],
      freteTabtrib: [doctoC?.freteTabtrib],
      freteValor: [doctoC?.freteValor],
      freteValoripi: [doctoC?.freteValoripi],
      funruralPerc: [doctoC?.funruralPerc],
      funruralValor: [doctoC?.funruralValor],
      horaalteracao: [doctoC?.horaalteracao],
      horainclusao: [doctoC?.horainclusao],
      icmsBasecalculo: [doctoC?.icmsBasecalculo],
      icmsValor: [doctoC?.icmsValor],
      icmssubstBasecalculo: [doctoC?.icmssubstBasecalculo],
      icmssubstValor: [doctoC?.icmssubstValor],
      icmsDesonValor: [doctoC?.icmsDesonValor],
      icrDescontopgto: [doctoC?.icrDescontopgto],
      icrFreteapagar: [doctoC?.icrFreteapagar],
      icrJurosvendor: [doctoC?.icrJurosvendor],
      icrOutrasdespesas: [doctoC?.icrOutrasdespesas],
      ieRg: [doctoC?.ieRg],
      infocustodescpgto: [doctoC?.infocustodescpgto],
      infocustofretepagar: [doctoC?.infocustofretepagar],
      infocustojurosvendor: [doctoC?.infocustojurosvendor],
      infocustooutrasdesp: [doctoC?.infocustooutrasdesp],
      inssPerc: [doctoC?.inssPerc],
      inssValor: [doctoC?.inssValor],
      ipiValor: [doctoC?.ipiValor],
      irfBc: [doctoC?.irfBc],
      irfIsentas: [doctoC?.irfIsentas],
      irfOutras: [doctoC?.irfOutras],
      irfPerc: [doctoC?.irfPerc],
      issValor: [doctoC?.issValor],
      jnfeLoteID: [doctoC?.jnfeLoteID],
      marca: [doctoC?.marca],
      mdfePesobrutocarga: [doctoC?.mdfePesoBrutoCarga],
      mdfeTotalmercadorias: [doctoC?.mdfeTotalMercadorias],
      mdfeUnPesoBrutoCarga: [doctoC?.mdfeUnPesoBrutoCarga],
      mdfeTipoEmitente: [doctoC?.mdfeTipoEmitente],
      ncmtotalvlimposto: [doctoC?.ncmtotalvlimposto],
      nfeQrcode: [doctoC?.nfeQrcode],
      nfeambiente: [doctoC?.nfeambiente],
      nfechaveacesso: [doctoC?.nfechaveacesso],
      nfecstat: [doctoC?.nfecstat],
      nfecstatcanc: [doctoC?.nfecstatcanc],
      nfedanfeimpresso: [doctoC?.nfedanfeimpresso],
      nfedescevento: [doctoC?.nfedescevento],
      nfedigestvalue: [doctoC?.nfedigestvalue],
      nfeeventos: [doctoC?.nfeeventos],
      nfeexportada: [doctoC?.nfeexportada],
      nfefinalidadeemissao: [doctoC?.nfefinalidadeemissao],
      nfeformaemissao: [doctoC?.nfeformaemissao],
      nfejustificativa: [doctoC?.nfejustificativa],
      nfelog: [doctoC?.nfelog],
      nfemodelo: [doctoC?.nfemodelo],
      nfeprotocpageObjectItemolo: [doctoC?.nfeprotocolo],
      nfeprotocolocanc: [doctoC?.nfeprotocolocanc],
      nferefCADCadastroID: [doctoC?.nferefCADCadastroID],
      nferefChaveacesso: [doctoC?.nferefChaveacesso],
      nferefDocumento: [doctoC?.nferefDocumento],
      nferefEmissao: [doctoC?.nferefEmissao],
      nferefNumerocoo: [doctoC?.nferefNumerocoo],
      nferefNumerodocto: [doctoC?.nferefNumerodocto],
      nfesituacao: [doctoC?.nfesituacao],
      nfetipoemissaodanfe: [doctoC?.nfetipoemissaodanfe],
      nfexml: [doctoC?.nfexml],
      nfexmlcanc: [doctoC?.nfexmlcanc],
      nfexmlcancdistribuicao: [doctoC?.nfexmlcancdistribuicao],
      nfexmldistribuicao: [doctoC?.nfexmldistribuicao],
      nfexmlretconssitnfe: [doctoC?.nfexmlretconssitnfe],
      nfexmlretenvinfe: [doctoC?.nfexmlretenvinfe],
      nfexmotivo: [doctoC?.nfexmotivo],
      nfexmotivocanc: [doctoC?.nfexmotivocanc],
      nome: [doctoC?.nome],
      pesobruto: [doctoC?.pesobruto],
      pesoliquido: [doctoC?.pesoliquido],
      fixaVolumes: [doctoC?.fixaVolumes],
      fixaPesoBruto: [doctoC?.fixaPesoBruto],
      fixaPesoLiquido: [doctoC?.fixaPesoLiquido],
      pisValor: [doctoC?.pisValor],
      prazoentrega: [doctoC?.prazoentrega],
      seguroBasecalculo: [doctoC?.seguroBasecalculo],
      seguroIsentos: [doctoC?.seguroIsentos],
      seguroOutros: [doctoC?.seguroOutros],
      seguroPercicms: [doctoC?.seguroPercicms],
      seguroTabred: [doctoC?.seguroTabred],
      seguroTabtri: [doctoC?.seguroTabtri],
      seguroValor: [doctoC?.seguroValor],
      seguroValoricms: [doctoC?.seguroValoricms],
      statusdocto: [doctoC?.statusdocto],
      statuslcto: [doctoC?.statuslcto],
      tabcfopId: [doctoC?.tabcfopId],
      tipolcto: [doctoC?.tipolcto],
      totalliquidoprodutos: [doctoC?.totalliquidoprodutos],
      totalprodutos: [doctoC?.totalprodutos],
      transpCidade: [doctoC?.transpCidade],
      transpCiot: [doctoC?.transpCiot],
      transpCnpjCpf: [doctoC?.transpCnpjCpf],
      transpDescricaoveiculo: [doctoC?.transpDescricaoVeiculo],
      transpEndereco: [doctoC?.transpEndereco],
      transpIdmotorista: [doctoC?.transpIdmotorista],
      transpMotoristaNome: [doctoC?.transpMotoristaNome],
      transpMotoristaCpf: [doctoC?.transpMotoristaCpf],
      transpTipoProprietario: [doctoC?.transpTipoProprietario],
      transpTipoTransportador: [doctoC?.transpTipoTransportador],
      transpIeRg: [doctoC?.transpIeRg],
      transpNome: [doctoC?.transpNome],
      transpPlacaVeiculo: [doctoC?.transpPlacaVeiculo],
      transpPlacaVeiculoReboque1: [doctoC?.transpPlacaVeiculoReboque1],
      transpPlacaVeiculoReboque2: [doctoC?.transpPlacaVeiculoReboque2],
      transpPlacaVeiculoReboque3: [doctoC?.transpPlacaVeiculoReboque3],
      transpRntrc: [doctoC?.transpRntrc],
      transpTaraveiculo: [doctoC?.transpTaraVeiculo],
      transpTipocarroceria: [doctoC?.transpTipoCarroceria],
      transpTiporodado: [doctoC?.transpTipoRodado],
      transpUf: [doctoC?.transpUf],
      transpUfveiculo: [doctoC?.transpUfVeiculo],
      uf: [doctoC?.uf],
      usuarioalteracao: [doctoC?.usuarioalteracao],
      usuarioinclusao: [doctoC?.usuarioinclusao],
      validade: [doctoC?.validade],
      valorarredtotaldocto: [doctoC?.valorarredtotaldocto],
      valortotalDocto: [doctoC?.valortotalDocto],
      valortotalDocto2: [doctoC?.valortotalDocto2],
      volumes: [doctoC?.volumes],
      dataConferencia: [doctoC?.dataConferencia],
      statusConferencia: [doctoC?.statusConferencia],
      usuarioConferencia: [doctoC?.usuarioConferencia],
      fcpValorTotal: [doctoC?.fcpValorTotal],
      fcpSubstValorTotal: [doctoC?.fcpSubstValorTotal],
      fcpSubstValorAnteriorTotal: [doctoC?.fcpSubstValorAnteriorTotal],
      ibsCbsBaseCalculo: [doctoC?.ibsCbsBaseCalculo],
      ibsValor: [doctoC?.ibsValor],
      cbsValor: [doctoC?.cbsValor],
      cteModal: [doctoC?.cteModal],
      cteTipoServico: [doctoC?.cteTipoServico],
      cteFinalidadeEmissao: [doctoC?.cteFinalidadeEmissao],
      cteTotalCarga: [doctoC?.cteTotalCarga],
      fatProdutoIdpred: [doctoC?.fatProdutoIdpred],
      produtoPred: [doctoC?.produtoPred],
      doctoRefs: [doctoC?.doctoRefs],
      rateioTotal: [doctoC?.rateioTotal],
      diretiva: [doctoC?.diretiva],
      contemBaixa: [doctoC?.contemBaixa],
      fatDoctoRefs: [doctoC?.fatDoctoRefs],
      uuid: [doctoC?.uuid],
      issueDate: [doctoC?.issueDate],
      updatedAt: [doctoC?.updatedAt],
      notaProcessada: [doctoC?.notaProcessada],
      idMlb: [doctoC?.idMlb],
      // Bloco NFS-e (Padrão Nacional) — só é usado quando a série é modelo 99.
      // O grupo é sempre criado para o formulário casar com o FatDoctoC do backend
      // (@Embeddable FatDoctoCNfse) em qualquer modelo de documento.
      // Nenhum controle usa `disabled`: controle desabilitado sai do `form.value` e o
      // payload chegaria sem os campos de retorno da SEFIN. Os campos só de leitura
      // ficam `readonly` no template.
      nfse: fb.group({
        nfseChaveacesso: [doctoC?.nfse?.nfseChaveacesso],
        nfseIdDps: [doctoC?.nfse?.nfseIdDps],
        nfseNdps: [doctoC?.nfse?.nfseNdps],
        nfseSerieDps: [doctoC?.nfse?.nfseSerieDps],
        nfseCompetencia: [doctoC?.nfse?.nfseCompetencia?.toString().split('T')[0]],
        nfseSituacao: [doctoC?.nfse?.nfseSituacao],
        nfseAmbiente: [doctoC?.nfse?.nfseAmbiente],
        nfseProtocolo: [doctoC?.nfse?.nfseProtocolo],
        nfseNsu: [doctoC?.nfse?.nfseNsu],
        nfseCodVerificacao: [doctoC?.nfse?.nfseCodVerificacao],
        nfseDataProcessamento: [doctoC?.nfse?.nfseDataProcessamento],
        nfseMotivo: [doctoC?.nfse?.nfseMotivo],
        nfseMunicipioIncidencia: [doctoC?.nfse?.nfseMunicipioIncidencia],
        nfseRegEspTrib: [doctoC?.nfse?.nfseRegEspTrib],
        nfseIssRetido: [doctoC?.nfse?.nfseIssRetido],
        nfseBaseCalculo: [doctoC?.nfse?.nfseBaseCalculo],
        nfseAliquotaIss: [doctoC?.nfse?.nfseAliquotaIss],
        nfseValorLiquido: [doctoC?.nfse?.nfseValorLiquido],
        nfseValorDeducoes: [doctoC?.nfse?.nfseValorDeducoes],
        nfseDescIncond: [doctoC?.nfse?.nfseDescIncond],
        nfseDescCond: [doctoC?.nfse?.nfseDescCond],
        nfseValorIr: [doctoC?.nfse?.nfseValorIr],
        nfseValorCsll: [doctoC?.nfse?.nfseValorCsll],
        nfseXmlDps: [doctoC?.nfse?.nfseXmlDps],
        nfseXml: [doctoC?.nfse?.nfseXml],
      }),
      items: fb.array([]),
      financRps: fb.array([]),
      produtoSearch: '',
      searchTransacao: '',
      searchDestinatario: '',
      searchTomador: '',
      searchRemet : '',
      searchConsig : '',
      searchVendedor: '',
      searchCondPg: '',
      searchLisPre: '',
      searchSerie: '',
      searchCidade: '',
      searchCidadeDest: '',
    });
  }
  


}
